var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 69,
    viewBox: "0 0 80 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006188"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 501",
    d: "M52.8388 19.9721L41.9155 6.1742L45.9399 1H59.9294L63.7621 6.1742L52.8388 19.9721Z",
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 502"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.834 17.6724L48.4263 5.79094L52.834 1.19165H59.3496L57.2416 5.79094L52.834 17.6724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9351 1.57492L48.4263 5.79094M48.4263 5.79094L52.834 17.6724L57.2416 5.79094M48.4263 5.79094L52.834 1.19165M57.2416 5.79094L59.3496 1.19165H52.834M57.2416 5.79094L52.834 1.19165M42.4856 5.79094H63.5657",
    stroke: "#7646D7",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 128",
    cx: 52.7697,
    cy: 41.8629,
    r: 25.269,
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 129",
    cx: 52.7697,
    cy: 41.8629,
    r: 20.8908,
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 501_2",
    d: "M16.991 37.4848L9.84888 28.4631L12.4802 25.08H21.6272L24.1332 28.4631L16.991 37.4848Z",
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector 502_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9914 35.9811L14.1094 28.2124L16.9914 25.2052H21.2516L19.8733 28.2124L16.9914 35.9811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4805 25.4558L14.1094 28.2124M14.1094 28.2124L16.9914 35.9811L19.8733 28.2124M14.1094 28.2124L16.9914 25.2052M19.8733 28.2124L21.2516 25.2052H16.9914M19.8733 28.2124L16.9914 25.2052M10.2251 28.2124H24.0082",
    stroke: "#7646D7"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 127",
    cx: 17.0147,
    cy: 52.0785,
    r: 15.0533,
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 130",
    cx: 17.0147,
    cy: 52.0786,
    r: 10.6751,
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.361a369ca69abb82a2d35ac0dcfe6f24.svg";
export { ForwardRef as ReactComponent };